import type { LinkProps } from '@chakra-ui/next-js'
import { chakra, Tooltip, useStyleConfig } from '@chakra-ui/react'
import NextLink from 'next/link'
import React from 'react'

type CustomLinkProps = {
  tooltip?: string
} & LinkProps

export const Link = React.forwardRef<HTMLAnchorElement, CustomLinkProps>(
  ({ children, tooltip, ...props }, ref) => {
    const styles = useStyleConfig('Link', props)
    const ChakraLink = React.useMemo(
      () =>
        chakra(NextLink, {
          shouldForwardProp: (prop) =>
            ['href', 'children', 'target', 'rel', 'style', 'onClick'].includes(prop),
        }),
      []
    )

    const LinkElement = (
      <ChakraLink ref={ref} __css={styles} {...props}>
        {children}
      </ChakraLink>
    )

    return tooltip ? (
      <Tooltip label={tooltip} hasArrow fontSize="12px" maxW={{ base: '300px', sm: '550px' }}>
        <chakra.span overflow="hidden" textOverflow="ellipsis" display="inline-flex">
          {LinkElement}
        </chakra.span>
      </Tooltip>
    ) : (
      LinkElement
    )
  }
)

Link.displayName = 'Link'
